import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { subscribeNewsletter } from "@/lib/api";

export const Newsletter = ({ dark = false }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email);
      toast.success(res.message);
      setEmail("");
    } catch {
      toast.error("Please enter a valid email and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="w-full max-w-md">
      <div
        className={`flex items-center gap-2 border-b ${
          dark ? "border-[#E8DCCF]/40" : "border-[#47394E]/30"
        } pb-2`}
      >
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          data-testid="newsletter-email-input"
          className={`flex-1 bg-transparent outline-none font-body text-base placeholder:opacity-50 ${
            dark ? "text-[#E8DCCF] placeholder:text-[#E8DCCF]" : "text-[#47394E] placeholder:text-[#47394E]"
          }`}
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit"
          className={`shrink-0 rounded-full p-2.5 transition-colors ${
            dark ? "bg-[#E8DCCF] text-[#47394E] hover:bg-[#A8B39B]" : "bg-[#47394E] text-[#E8DCCF] hover:bg-[#B7926A]"
          }`}
          aria-label="Subscribe"
        >
          <ArrowRight size={18} />
        </button>
      </div>
    </form>
  );
};
